import { Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom';
import AuthContainer from '../shared/AuthContainer';

const LoginDesktop = ({ handleSubmit, email, setEmail, status, onGoogleAuth }) => {

    return (
        <>
            <div className="pt-5 login-section">    
                <Row className="login-header">
                    <Col xs={1} md={2}></Col>
                    <Col xs={10} md={8}>       
                            
                        <Row className="text-center login-title-row">
                            <Col className="login-title">Login</Col>
                        </Row>

                        {/* Shared Auth Container */}
                        <Row className="mt-4">
                            <Col>
                                <div className="login-form-container">
                                    <AuthContainer 
                                        email={email}
                                        setEmail={setEmail}
                                        onGoogleAuth={onGoogleAuth}
                                        onMagicLinkSubmit={handleSubmit}
                                        googleButtonText="Login with Google"
                                        magicLinkButtonText="Login with email"
                                        disabled={false}
                                    />
                                    
                                    {status && <p className="mt-3 text-center">{status}</p>}
                                    
                                    {/* Legal Agreement - Inside Card */}
                                    <div className="text-center mt-4 mb-2">
                                        <p className="small mb-0" style={{ color: '#94a3b8' }}>
                                            By logging in, you agree to our{' '}
                                            <Link to="/terms" className="text-decoration-underline" style={{ color: '#94a3b8' }}>Terms</Link>
                                            {' '}and{' '}
                                            <Link to="/privacy" className="text-decoration-underline" style={{ color: '#94a3b8' }}>Privacy Policy</Link>.
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {/* Secondary Link */}
                        <Row className="mt-4">
                            <Col>
                                <div className="text-center">
                                    <p className="login-secondary-text">
                                        Don't have an account?{' '}
                                        <Link to="/onboarding/platform" className="login-link">
                                            Get started
                                        </Link>
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Col>                            
                </Row>
            </div>
        </>
    );
};

export default LoginDesktop;